import * as React from 'react';
import cn from 'clsx';

import * as styles from './styles.css';

export interface IResizableWrap {
  width?: number | string;
  height?: number | string;
  resizeChildren?: boolean;
}
/** Оболочка-воркэраунд для задания кастомных размеров китовым иконкам */
export const ResizableWrap: React.FC<React.PropsWithChildren<IResizableWrap>> = ({
  children,
  width,
  height,
  resizeChildren,
}) => {
  return (
    <span
      className={cn(styles['wrap'], resizeChildren && styles['resize-children'])}
      style={{
        width,
        height,
      }}
    >
      {children}
    </span>
  );
};
